import React, { useEffect, useState, useRef } from 'react'
import PassPreview from '../component/pass-preview-public'
import { useParams } from 'react-router-dom/dist'
import Api from 'utils/api'
import addtowalletAndroid from '../../../../assets/images/add-to-walletpasses.png'
import addtogooglewallet from '../../../../assets/images/Add_to_Google_Wallet.png'
import addtowalletApple from '../../../../assets/images/add-to-apple-wallet-logo.png'
import addtosamsungwallet from '../../../../assets/images/add-to-samsung-wallet.png'
import Passback from './passback'
import { Tooltip } from 'react-tooltip'
import env from '../../../../config'
import SamsungWallet from './SamsungWalletBtn'
import Modal from 'components/modal'

const DEVICES = {
  APPLE: 'apple',
  ANDROID: 'android',
  SAMSUNG: 'samsung',
}

function Download() {
  const { passCode } = useParams()
  const [pass, setPass] = useState(false)
  const [showPassback, setShowPassback] = useState(false)
  const [device, setDevice] = useState(DEVICES.APPLE)
  const [open, setOpen] = useState(false)
  const [CDATA, setCDATA] = useState()

  const GoogleWalletUrl =
    env.API_URL +
    '/v1/pass/google?pass_code=' +
    passCode +
    '&device_name=' +
    device
  const walletURL =
    env.API_URL +
    '/v1/pass/apple?pass_code=' +
    passCode +
    '&device_name=' +
    device

  const SamsungWalletUrl =
    env.API_URL +
    '/v1/pass/samsung?pass_code=' +
    passCode +
    '&device_name=' +
    device

  useEffect(() => {
    const fetchPassByCode = async () => {
      const { response } = await Api(
        `/pass/passByCode?passCode=${passCode} `,
        'get',
        { notify: false }
      )
      //console.log('response.data', response.data)
      if (response) {
        setPass(response.data)
      }
    }

    const fetchSamsungCDATA = async () => {
      const { response } = await Api(
        `/pass/samsung?pass_code=${passCode}&device_name=device`,
        'get',
        { notify: false }
      )
      if (response.data) setCDATA(response.data.cdata)
    }

    fetchSamsungCDATA()
    fetchPassByCode()
  }, [passCode])

  const togglePassback = () => {
    setShowPassback(!showPassback)
  }

  useEffect(() => {
    const userAgent = navigator.userAgent
    const samsungKeywords = ['samsungbrowser', 'SM-', 'GT-']
    const isSamsung = samsungKeywords.some((keyword) =>
      userAgent.includes(keyword)
    )
    // if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream)
    //   setDevice(DEVICES.APPLE)
    // else setDevice(DEVICES.ANDROID)
    if (isSamsung && /Android/.test(userAgent)) {
      setDevice(DEVICES.SAMSUNG)
    } else if (
      /iPad|iPhone|iPod|Macintosh/.test(userAgent) &&
      !window.MSStream
    ) {
      setDevice(DEVICES.APPLE)
    } else {
      setDevice(DEVICES.ANDROID)
    }
  }, [])


  const handleSamsungButton = () => {
    if (!window.samsungWallet || !CDATA) {
      console.error('Samsung Wallet SDK or CDATA not available.');
      return;
    }
    window.samsungWallet.addButton({
      cardId: '3idferhqvle00',
      cdata: CDATA,
      partnerCode: '4118525246301138240',
      RDClickUrl:
        'https://us-rd.mcsvc.samsung.com/statistics/click/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=4063269063441135936;co=4118525246301138240;cp=1288017491089625089;si=24;pg=4058691328745130560;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4122463848999138496;li=0',
      RDImpressionUrl:
        'https://us-rd.mcsvc.samsung.com/statistics/impression/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=4063269063441135936;co=4118525246301138240;cp=1288017491089625089;si=24;pg=4058691328745130560;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4122463848999138496;li=0',
      targetId: 'TARGET_ID_1',
      buttonId: 'samsung_wallet_btn',
      target: 'wallet',
      showForced: true,
    })
    window.samsungWallet.addButton({
      cardId: '3idferhqvle00',
      cdata: CDATA,
      partnerCode: '4118525246301138240',
      RDClickUrl:
        'https://us-rd.mcsvc.samsung.com/statistics/click/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=4063269063441135936;co=4118525246301138240;cp=1288017491089625089;si=24;pg=4058691328745130560;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4122463848999138496;li=0',
      RDImpressionUrl:
        'https://us-rd.mcsvc.samsung.com/statistics/impression/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=4063269063441135936;co=4118525246301138240;cp=1288017491089625089;si=24;pg=4058691328745130560;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4122463848999138496;li=0',
      targetId: 'TARGET_ID_2',
      buttonId: 'samsung_wallet_btn',
      target: 'wallet',
      showForced: true,
    })
    window.samsungWallet.addButton({
      cardId: '3idferhqvle00',
      cdata: CDATA,
      partnerCode: '4118525246301138240',
      RDClickUrl:
        'https://us-rd.mcsvc.samsung.com/statistics/click/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=4063269063441135936;co=4118525246301138240;cp=1288017491089625089;si=24;pg=4058691328745130560;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4122463848999138496;li=0',
      RDImpressionUrl:
        'https://us-rd.mcsvc.samsung.com/statistics/impression/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=4063269063441135936;co=4118525246301138240;cp=1288017491089625089;si=24;pg=4058691328745130560;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4122463848999138496;li=0',
      targetId: 'TARGET_ID_3',
      buttonId: 'samsung_wallet_btn',
      target: 'wallet',
      showForced: true,
    })
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOpen(true)
      // handleSamsungButton()
    }, 1000)
    return () => clearTimeout(timeout)
  }, [])



  const Buttons = ({ samsungid }) => {
    return (
      <div className='tw-flex tw-flex-col sm:tw-flex-row tw-justify-center tw-items-center tw-gap-4'>
        {/* APPLE OR WALLETPASS BUTTON */}
        {pass?.designId?.appleWallet && <a
          href={
            device == DEVICES.APPLE
              ? walletURL
              : `https://walletpass.io?u=${encodeURIComponent(walletURL)}`
          }
        >
          <img
            src={
              device == DEVICES.APPLE ? addtowalletApple : addtowalletAndroid
            }
            alt=''
            className='tw-w-36  tw-h-auto tw-mt-3 tw-mb-3 tw-cursor-pointer'
          />
        </a>}

        {/* GOOGLE WALLET BUTTON */}
        {pass?.designId?.googleWallet &&
          <a href={GoogleWalletUrl} target='_blank' rel='noopener noreferrer'>
            <img
              src={addtogooglewallet}
              alt='Add to Apple Wallet'
              className='tw-w-36 tw-h-auto tw-cursor-pointer'
            />
          </a>}

        {/* SAMSUNG WALLET BUTTON */}
        {(device === DEVICES.SAMSUNG || true) && (pass?.designId?.samsungWallet) ? (
          // <a href={SamsungWalletUrl} target='_blank' rel='noopener noreferrer'>
          //   <img
          //     src={addtosamsungwallet}
          //     alt='Add to Samsung Wallet'
          //     className='tw-w-36 tw-h-auto tw-cursor-pointer'
          //   />
          // </a>
          // <samsung:wallet
          //   cardid='3idferhqvle00'
          //   cdata='CDATA'
          //   partnercode='4118525246301138240'
          //   buttonid='samsung_wallet_btn'
          //   rdclickurl='https://us-rd.mcsvc.samsung.com/statistics/click/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=1287098641034510350;co=4030093436155138240;cp=1288017491089625089;si=24;pg=101212967375212546;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4030093588496138240;li=0&utm_source=partner&utm_medium=web'
          //   rdimpressionurl='https://us-rd.mcsvc.samsung.com/statistics/impression/addtowlt?ep=C50C3754FEB24833B30C10B275BB6AB8;cc=GC;ii=1287098641034510350;co=4030093436155138240;cp=1288017491089625089;si=24;pg=101212967375212546;pi=Aqz68EBXSx6Mv9jsaZxzaA;tp=4030093588496138240;li=0&utm_source=partner&utm_medium=web'
          // ></samsung:wallet>
          // <SamsungWallet cData={CDATA} />
          <div id={samsungid}>
            <img id="samsung_wallet_btn" 
            // src="https://us-cdn-gpp.mcsvc.samsung.com/lib/image/btnSW/wallet-card-dark.png"
            src="/img/Add_to_Samsung_Wallet_badge.png"
             className='tw-w-[150px]'  />
          </div>
        ) : null}


      </div>
    )
  }


  return (
    <>

      <div className='tw-flex tw-flex-col-reverse sm:tw-flex-col'>

        <div className='tw-flex tw-flex-row  tw-justify-center tw-items-center tw-gap-4 tw-mx-auto sm:tw-w-[530px] tw-w-[90%]'>

          <div className='tw-flex tw-items-center'>
            <Buttons samsungid="TARGET_ID_1" />

            <div
              data-tooltip-id='detail'
              data-tooltip-content={showPassback ? 'Pass' : 'Details'}
              className=' tw-p-1 tw-rounded-full tw-cursor-pointer tw-w-fit sm:tw-block tw-hidden'
            >
              <svg
                onClick={togglePassback}
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth='1.5'
                stroke='currentColor'
                className='tw-w-8 tw-h-8 tw-cursor-pointer'
              >
                <path
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  d='M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
                />
              </svg>
              <Tooltip className='tw-z-50 tw-ml-16' place='top' id='detail' />
            </div>
          </div>

        </div>
        <div>
          <div className='tw-flex tw-justify-center tw-items-center tw-mt-8'>
            {!showPassback && pass ? <PassPreview values={pass} /> : null}
          </div>
          {showPassback && pass && <Passback pass={pass} />}
        </div>

        <div className='tw-flex tw-flex-row  tw-justify-end tw-items-center tw-gap-4 tw-mx-auto sm:tw-w-[530px] tw-w-[90%]'>
          <div
            data-tooltip-id='detail'
            data-tooltip-content={showPassback ? 'Pass' : 'Details'}
            className=' tw-p-1 tw-rounded-full tw-cursor-pointer tw-w-fit tw-block sm:tw-hidden'
          >
            <svg
              onClick={togglePassback}
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              className='tw-w-8 tw-h-8 tw-cursor-pointer'
            >
              <path
                stroke-linecap='round'
                stroke-linejoin='round'
                d='M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
              />
            </svg>
            <Tooltip className='tw-z-50 tw-ml-16' place='top' id='detail' />
          </div>
        </div>
      </div>

      <Modal open={open} onClose={() => setOpen(false)} >
        <div className='tw-p-4 sm:tw-w-[430px] tw-w-[90%] '>
          <div className='tw-flex tw-justify-end'>
            <span onClick={() => setOpen(false)} className='tw-font-bold tw-cursor-pointer tw-p-2'>x</span>
          </div>
          <h1 className='tw-font-bold tw-pb-5'>Add your card to you digital Wallet</h1>
         <Buttons />
        </div>

      </Modal>
    </>
  )
}

export default Download
